module.exports = __webpack_public_path__ + "static/media/document-contextualization.2880a5aa.png";